import { Component, OnInit, Input } from "@angular/core";

import { InsaCronService } from "../../../../../insa-services";
import { FormGroup } from "@angular/forms";
import { ObjectCreationNotifierDetails } from "../../../../../insa-models";

@Component({
    selector: "edit-objectCreationNotifierActivity-details",
    template: require("./edit-objectCreationNotifierActivity-details.component.html")
})

export class EditObjectCreationNotifierActivityDetailComponent implements OnInit{

    _acitivityID:number = null;

    @Input() editObjectCreationNotifierForm: any;
    @Input() set objectCreationNotifierDetails(activityData: any){
        this._acitivityID = activityData; 
    }

    notifierData: ObjectCreationNotifierDetails = new ObjectCreationNotifierDetails();

    private notifiers: any = [];

    constructor(private _insaChronosService: InsaCronService){ }

    ngOnInit(){
        this._insaChronosService.getObjectNotifierTypes().subscribe(data => this.notifiers = data);
        if(this._acitivityID !== undefined && this._acitivityID !== null){
            this._insaChronosService.getObjectNotifierDetailsById(this._acitivityID).subscribe((n: any) => this.notifierData = n)
        }
        
    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-activities-detail/objectCreationNotifierActivity-details/edit-objectCreationNotifierActivity-details.component.ts